/* @flow */
import produce from 'immer'

export default function reducer(
  state,
  action: any
) {
  const initialState = action.__initialData.defaultProps
  return produce(state, draft => {
    switch (action.type) {
      case 'CHANGE_COPYRIGHT':
        draft.copyrightText = action.value
        return
      case 'ADD_SOCIAL':
        draft.socials.push(initialState.socials[0])
        return
      case 'REMOVE_SOCIAL':
        const { idx } = action.value
        draft.socials.splice(idx, 1)
        return
      case 'CHANGE_SOCIAL_URL': {
        const { idx, link } = action.value
        draft.socials[idx].socialUrl = link
        return
      }
      case 'CHANGE_SOCIAL_ICON': {
        const { idx, iconName } = action.value
        draft.socials[idx].icon = iconName
        return
      }
    }
  })
}
